// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FollowUp90DayForm__wrapper__1ba1W","submitResult":"FollowUp90DayForm__submitResult__16oxm","toggleHeadline":"FollowUp90DayForm__toggleHeadline__1KJma","collapseIcon":"FollowUp90DayForm__collapseIcon__SNKur","headlineText":"FollowUp90DayForm__headlineText__2_To8","sliderWrapper":"FollowUp90DayForm__sliderWrapper__3MTzE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowUp90DayForm/FollowUp90DayForm.css
// module id = 1839
// module chunks = 0